var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreeDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.92969C8.86719 9.92969 9.5625 9.23438 9.5625 8.36719C9.5625 7.50781 8.86719 6.8125 8 6.8125C7.13281 6.8125 6.4375 7.50781 6.4375 8.36719C6.4375 9.23437 7.13281 9.92969 8 9.92969Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.7344C8.86719 15.7344 9.5625 15.0391 9.5625 14.1719C9.5625 13.2891 8.86719 12.5937 8 12.5937C7.13281 12.5937 6.4375 13.2891 6.4375 14.1719C6.4375 15.0391 7.13281 15.7344 8 15.7344Z",
    fill: "#7B7B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.14844C8.86719 4.14844 9.5625 3.44531 9.5625 2.5625C9.5625 1.70312 8.86719 1 8 1C7.13281 1 6.4375 1.70312 6.4375 2.5625C6.4375 3.44531 7.13281 4.14844 8 4.14844Z",
    fill: "#7B7B7B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ThreeDots.c9decab838b841f79711d124b57c6c88.svg";